'use client'
import { useState } from 'react'

import DonationButton from '@/components/atoms/Buttons/DonationButton'
import Container from '@/components/atoms/Container'
import Logo from '@/components/atoms/Logo'

import MenuButton from '@/components/atoms/Buttons/MenuButton'

import Navigation from '@/components/molecules/Navigation'
import { GTM_EVENT_SECTION } from '@/helpers/gtm'
import useIsMobile from '@/hooks/useIsMobile'
import { NonSocialMenuItemType } from '@/types'

const Header = ({ items }: { items: NonSocialMenuItemType[] }) => {
  const isMobile = useIsMobile({
    breakpoint: 768,
  })

  const [menuState, setMenuState] = useState('closed')

  const onClick = () => {
    setMenuState(menuState === 'closed' ? 'opened' : 'closed')
  }

  return (
    <header
      className='airc-header'
      data-status={menuState}
    >
      <Container>
        <div className='airc-header--wrapper'>
          <Logo />
          <div className='airc-header--navigation'>
            <div className='airc-header--navigation__menu'>
              <Navigation
                menu={{
                  direction: 'row',
                  items,
                }}
              />
            </div>
            <div className='airc-header--navigation__action'>
              <DonationButton
                gtmZone={
                  isMobile
                    ? GTM_EVENT_SECTION.DONA_CTA_FOOTER
                    : GTM_EVENT_SECTION.DONA_CTA_HEADER
                }
              />
            </div>
          </div>
          <MenuButton
            onClick={onClick}
            status={menuState}
          />
        </div>
      </Container>
    </header>
  )
}

export default Header
